import { IonBackButton, IonButtons, IonCardContent, IonContent, IonHeader, IonLoading, IonPage, IonSelect, IonSelectOption, IonTitle, IonToolbar } from "@ionic/react"
import { arrowBackCircleSharp } from "ionicons/icons"
import { useContext, useEffect, useRef, useState } from "react";
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { ApplicationContext } from "../../ApplicationState";
import * as ApiService from "../../services/ApiService";
// import 'tabulator-tables/dist/css/tabulator.min.css';
// import 'survey-analytics/survey.analytics.tabulator.min.css';
import * as SurveyAnalytics from "survey-analytics";
import { Tabulator } from 'survey-analytics/survey.analytics.tabulator';
import { Model } from "survey-core";
import { PlotlySetup, VisualizationPanel, VisualizerBase } from "survey-analytics";
import "survey-analytics/survey.analytics.css";
import { Button, CircularProgress, createTheme, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, getCardHeaderUtilityClass, ThemeProvider, Typography } from "@mui/material";
import MaterialTable from "material-table";
import Header from "../../components/Header/Header";
import tableIcons from "../../components/Notifications/MaterialTableIcons";

var _ = require("lodash");

export const UserSurveyResponses = () => {
    const location: any = useLocation();
    const defaultMaterialTheme = createTheme()
    const tableRef = useRef(null)
    const analyticsContainer = useRef(null);

    const [userData, setUserData] = useState([])

    const groupsColumns = [
        {
            field: "surveyName",
            title: "Survey Name",
            width: 0
        },

        {
            field: "completedOn",
            title: "completed On",
            width: 0
        },

        {
            field: "View Details",
            title: "",
            width: 0,
            render: rowData => {
                return (
                    <Button onClick={() => {
                    }} variant="contained">View Details</Button>
                )
            }
        },
    ];

    const ResultColumns = [
        {
            field: "title",
            title: "Question",
            width: 0
        },

        {
            field: "value",
            title: "Answer",
            width: 0
        },
    ];


    useEffect(() => {
        if (location?.state) {
            //const groupedSurvey = groupedSurveyData(location?.state?.userSurveyResponses)

            // const categoryBySurveyName = _.groupBy(location?.state?.userSurveyResponses, 'surveyName')
            // console.log("🚀 ~ useEffect ~ location?.state?.userSurveyResponses:", location?.state?.userSurveyResponses)

            //console.log("🚀 ~ useEffect ~ categoryBySurveyName:", categoryBySurveyName)

            // const tableData = Object.entries(categoryBySurveyName)

            // const tableData = Object.entries(categoryBySurveyName).flatMap(([group, members]) => {
            //     return members.map((member) => ({ ...member, group }))
            // }
            // );
            // console.log("🚀 ~ tableData ~ tableData:", tableData)


            setUserData(location?.state?.userSurveyResponses)

            // getCharts()
        }
    }, [])

    // // Function to group by surveyName
    // const groupedSurveyDataa = location?.state?.userSurveyResponses.reduce((acc, curr) => {
    //     //console.log("🚀 ~ groupedSurveyDataa ~ acc:", acc)

    //     const { surveyDataToRender, surveyName, completedOn, ...rest } = curr;

    //     // Find existing survey group
    //     let survey = acc.find(item => item.surveyName === surveyName);

    //     if (!survey) {
    //         // If survey group does not exist, create a new one
    //         survey = {
    //             surveyName,
    //             responses: surveyDataToRender
    //         };
    //         acc.push(survey);
    //     }

    //     // Add response to the relevant survey group
    //     survey.responses.push({
    //         timestamp: completedOn,
    //         response: surveyDataToRender || {}, // Include additional response data
    //     });

    //     return acc;
    // }, []);

    // Transform database results for SurveyJS Analytics
    const transformResults = (resultsFromDb) => {
        return resultsFromDb.map((result) => {

            const surveyResponse = JSON.parse(result.surveyData);

            return {
                ...surveyResponse,
                CompletedOn: result.completedOn,
            };
        });
    };

    const getCharts = () => {
        const survey = new Model(location?.state?.userSurveyResponses.surveyJson);

        const resultSurvey = _.map(location?.state?.userSurveyResponses, sur => {
            return sur.surveyResult
        })

        const visPanel = new VisualizationPanel(
            survey.getAllQuestions(),
            location?.state?.userSurveyResponses.surveyResult
        );
        visPanel.render(analyticsContainer.current);

    }

    return (
        <IonPage>
            {/* <Header /> */}
            <IonHeader>
                <IonToolbar color="light">
                    <IonButtons slot="start">
                        <IonBackButton
                            text="Go Back"
                            icon={arrowBackCircleSharp}
                            defaultHref="/"
                        />
                    </IonButtons>
                    <IonTitle>Survey Responses</IonTitle>
                </IonToolbar>
            </IonHeader>
            {_.isEmpty(location.state) ? (
                <CircularProgress
                    size={24}
                    sx={{
                        color: "#3880ff",
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        marginTop: "-12px",
                        marginLeft: "-12px",
                    }}
                />
            ) : (
                <IonContent>
                    <ThemeProvider theme={defaultMaterialTheme}>
                        <MaterialTable
                            tableRef={tableRef}
                            localization={{
                                body: {
                                    emptyDataSourceMessage: (
                                        <Typography>
                                            No Surveys to display
                                        </Typography>
                                    ),
                                },
                            }}
                            style={{ width: "100%" }}
                            title=""
                            icons={tableIcons}
                            columns={groupsColumns}
                            options={{
                                pageSizeOptions: [5, 10],
                                defaultExpanded: true,
                            }}

                            components={{
                                OverlayLoading: props => (<div style={{ justifyContent: "center", alignItems: 'center' }}> Loading... </div>)
                            }}
                            page={5}
                            data={userData === null ? [] : userData}

                            detailPanel={(rowData) => {

                                return (
                                    <ThemeProvider theme={defaultMaterialTheme}>
                                        <MaterialTable
                                            tableRef={tableRef}
                                            localization={{
                                                body: {
                                                    emptyDataSourceMessage: (
                                                        <Typography>
                                                            Nothing to display
                                                        </Typography>
                                                    ),
                                                },
                                            }}
                                            style={{ width: "100%" }}
                                            title=""
                                            icons={tableIcons}
                                            columns={ResultColumns}
                                            options={{
                                                pageSizeOptions: [5, 10],
                                                defaultExpanded: true
                                            }}

                                            components={{
                                                OverlayLoading: props => (<div style={{ justifyContent: "center", alignItems: 'center' }}> Loading... </div>)
                                            }}
                                            page={5}
                                            data={rowData.surveyDataToRender === null ? [] : rowData.surveyDataToRender}

                                        />
                                    </ThemeProvider>
                                )

                            }
                            }
                            onRowClick={(event, rowData, togglePanel) => togglePanel()}

                        />
                    </ThemeProvider>

                    <div>
                        <div className="sa-question__select" ref={analyticsContainer} style={{ width: "100%", height: "600px" }}></div>
                    </div>
                </IonContent>
            )
            }
        </IonPage>
    )
}